import { useEffect } from 'react'

import { Box, Button, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { useSyncValidation } from 'modules/integrations/hooks/SyncContext/useSyncValidation'

import Unavailable from './Unavailable'

interface Props {
  integrationName: string
  onSync: () => Promise<void>
  syncing: boolean
  isDeleted: boolean
}

const Outdated = ({ integrationName, onSync, syncing, isDeleted }: Props) => {
  const { fetchIssues, issues, issuesLoading } = useSyncValidation()

  useEffect(() => {
    fetchIssues()
  }, [fetchIssues])

  if (issuesLoading) {
    return (
      <Box width="full" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  if (issues.length > 0) {
    return <Unavailable issues={issues} />
  }

  const message = isDeleted
    ? i18n.t('payroll_integrations.employee_update_leave.outdated.message_deleted', {
        integration_name: integrationName,
      })
    : i18n.t('payroll_integrations.employee_update_leave.outdated.message_edited', {
        integration_name: integrationName,
      })

  return (
    <Box
      background="grey200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs008' }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.employee_update_leave.outdated.title', {
          integration_name: integrationName,
        })}
      </Text.Header2>
      {message}
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.employee_update_leave.outdated.submit', {
          integration_name: integrationName,
        })}
      </Button>
    </Box>
  )
}

export default Outdated
